export default "__VITE_ASSET__DpPUPw16__"